import { ActivatedRoute } from '@angular/router';
import { OrganisationService } from './../../Service/organisation.service';
import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { takeUntil } from 'rxjs/operators';
import { Global } from 'src/app/Service/global.service';
import { Console } from 'console';

@Component({
  selector: 'app-organisation',
  templateUrl: './organisation.component.html',
  styleUrls: ['./organisation.component.scss']
})
export class OrganisationComponent implements OnInit {
  oldSourceOrganigramme = [];
  dg = [];
  dRegional = [];
  dPoleStrategique = [];
  dPoleTechnique = [];
  dGouvernance = [];
  dIFP = [];
  dMissions = [];
  dDepartementN1 = [];
  dDepartementN2 = [];
  dDepartementN3 = [];
  dSupport = [];
  directions = [];
  directionsTab = [];
  langue = '';
  selectedOrga = false;
  miniOrganisation = [];
  allOrganisation = [];
  selectedDirection = '';
  showItemProfile;


  constructor(public global: Global, private service: OrganisationService) { }

  ngOnInit(): void {
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      this.langue = lg.code
      this.dg = [];
      this.dRegional = [];
      this.dPoleStrategique = [];
      this.dSupport = [];
      this.dPoleTechnique = [];
      this.dGouvernance = []
      this.dIFP = [];
      this.dMissions = [];
      this.dDepartementN1 = [];
      this.dDepartementN2 = [];
      this.dDepartementN3 = [];
      this.directions = [];
      this.directionsTab = [];

      this.service.getOrganisaitonData().subscribe(datas => {
        let i = 0;
        this.allOrganisation = datas['value'];
        this.allOrganisation.sort((a, b) => {
          if (a.Order0 === null) return 1;
          if (b.Order0 === null) return -1;
          return a.Order0 - b.Order0;
        });
        this.allOrganisation.forEach(element => {
          if (element.Niveau === '1') {
            this.dg.push({
              metadata: element
            });
          }

          if (element.Direction.indexOf('Gouvernance & Contrôle') !== -1 && element.Niveau === '3') {
            this.dGouvernance.push({
              metadata: element,
              type: 'pole'
            });
          }
          if (element.Direction.indexOf('Stratégie & Pilotage') !== -1 && element.Niveau === '3') {
            this.dPoleStrategique.push({
              metadata: element,
              type: 'pole'
            });
          }
          if (element.Direction.indexOf('Ressources') !== -1 && element.Niveau === '3') {
            this.dSupport.push({
              metadata: element,
              type: 'pole'
            });
          }
          if (element.Direction.indexOf('Métiers') !== -1 && element.Niveau === '3') {
            this.dPoleTechnique.push({
              metadata: element,
              type: 'pole'
            });
          }

          //   if(element.Direction.indexOf('Institut de Formation portuaire') !== -1 && (element.Niveau === '22') ){
          //     this.dIFP.push({
          //       metadata:element,
          //       type:'pole'
          //     });
          //   }
          //   if(element.Entite.indexOf('DMC') !== -1 && (element.Niveau === '22') )
          // {
          //     this.dMissions.push({
          //       metadata:element,
          //       type:'pole'
          //     });
          //   }
          // if(element.Niveau ==='21') {

          //   this.dRegional.push(
          //     {
          //       metadata: element,
          //       type:'region'
          //     });
          // }
          if (element.Niveau === '21') {

            const obj = {
              metadata: element,

              IntitulePoste: this.trunkIntitule(element.IntitulePoste),
              type: 'region'
            };
            if (i < 4) {
              this.dDepartementN1.push(obj)
            } else if (i < 8) {
              this.dDepartementN2.push(obj)
            }
            else {
              this.dDepartementN3.push(obj)
            }
            i++;
          }
          if (this.directions.indexOf(element.Direction.trim()) === -1) {
            this.directions.push(element.Direction.trim());

            this.directionsTab.push({
              fr: element.Direction.trim(),
              ar: element.IntitulePosteAR,
              en: element.IntitulePosteEN,
            })
            
           
          }


        });
      });

    });
  }
  changeDirection() {
    if (this.selectedDirection === 'Direction Générale') {
      this.selectedOrga = false;

    } else {
      this.allOrganisation.forEach(element => {
        if (this.selectedDirection === element.Direction && (element.Niveau === '2' || element.Niveau === '21' || element.Niveau === '22')) {
          const obj =
          {
            metadata: element,
            type: 'region'
          };
          this.getDirection(obj);
        }
      })

    }

  }


  trunkIntitule(data) {
    if (data.length > 60) {
      return data.replace("Directeur","Direction").replace("Directrice","Direction").substring(0, 60) + '...'
    } else {
      return data.replace("Directeur","Direction").replace("Directrice","Direction");
    }
  }
  bacKOrganisation() {
    if (this.oldSourceOrganigramme.length === 0 && (this.oldSourceOrganigramme['Responsable'] === null) || (this.oldSourceOrganigramme['Responsable'] === undefined)) {
      this.selectedOrga = false;
      this.miniOrganisation = [];
    } else {
      this.miniOrganisation = this.oldSourceOrganigramme;
      this.oldSourceOrganigramme = [];

    }
  }
  getDirection(item) {
    
    this.oldSourceOrganigramme = this.miniOrganisation !== [] ? this.miniOrganisation : [];
    if ((item['Members'] === null || item['Members'] === undefined)
      && (item['Responsable'] === null || item['Responsable'] === undefined)) {
        
      this.miniOrganisation = [];
      const orga = [];
      orga['Responsable'] = item.metadata === null || item.metadata === undefined ? item : item.metadata;
      // Directeur Pole
      if (item.metadata.Niveau === '2') {
        orga['Members'] = [];
        this.allOrganisation.forEach(element => {
          // Directeur Centraux
          if (element.Direction === item.metadata.Direction && element.Niveau === '3') {
            const objDivision = [];
            objDivision['Responsable'] = element
            objDivision['Members'] = [];
            const subDept = element.Entite + '-'
            this.allOrganisation.forEach(elmnt => {
              // Responsable Division et service
              if (elmnt.Division !== null && elmnt.Division !== undefined && elmnt.Division.indexOf(subDept) !== -1
                && elmnt.IntitulePoste.toUpperCase().indexOf('CHEF DE LA DIVISION') !== -1) {

                const objService = [];
                objService['Responsable'] = elmnt
                objService['Members'] = [];
                // this.allOrganisation.forEach(ser => {
                //   if(ser.Division !== null && ser.Division !== undefined && elmnt.Division === ser.Division 
                //     && ser.IntitulePoste.toUpperCase().indexOf('CHEF DE LA DIVISION') === -1 )
                //   {
                //     const service = [];
                //     service['Responsable']=ser;
                //     objService['Members'].push(service)
                //   }
                // }) ;

                objDivision['Members'].push(objService);
              }
            });
            orga['Members'].push(objDivision);
            // Directeur Central
          }
        });
      } else if (item.metadata.Niveau === '3' || item.metadata.Niveau === '22') {

        orga['Members'] = [];
        this.allOrganisation.forEach(element => {
          const subDept = item.metadata.Entite + '-'
          if (element.Division !== null && element.Division !== undefined && element.Division.indexOf(subDept) !== -1
            && element.IntitulePoste.toUpperCase().indexOf('CHEF DE LA DIVISION') !== -1 && element.Direction === item.metadata.Direction) {

            const division = [];
            division['Responsable'] = element;
            division['Members'] = [];
            // this.allOrganisation.forEach(elmnt =>  {
            //   if(elmnt.Division !== null && elmnt.Division !== undefined && element.Division === elmnt.Division 
            //     && elmnt.IntitulePoste.toUpperCase().indexOf('CHEF DE LA DIVISION') === -1 ) {
            //     const  service = [];
            //     service['Responsable']=elmnt;
            //       division['Members'].push(service);
            //     }

            // });
            orga['Members'].push(division);
          }

        });          
        if(item.metadata.Entite ==="DIE" ){
         // orga['Members'] = [];
          this.allOrganisation.forEach(element => {
            const subDept = item.metadata.Entite + '-'
            if (element.Niveau === '22') {
  
              const division = [];
              division['Responsable'] = element;
              division['Members'] = [];
              this.allOrganisation.forEach(elmnt =>  {
                if(elmnt.Division !== null && elmnt.Division !== undefined && element.Entite === elmnt.Entite 
                  && elmnt.IntitulePoste.toUpperCase().indexOf('CHEF DU SERVICE') === -1 ) {
                  const  service = [];
                  service['Responsable']=elmnt;
                    division['Members'].push(service);
                  }
  
              });
              orga['Members'].push(division);
            }
  
          });   
          }
      } else if (item.metadata.Niveau === '21') { // Directeur  Regional
        
        orga['Members'] = [];
        const divisionChecked = [];

        this.allOrganisation.forEach(element => {

          const subDept = item.metadata.Entite
          const direction = item.metadata.Direction;
         // console.log(element.Grade.indexOf('Chef de département B'))
          if (element.Grade.indexOf('Chef de département B') !== -1 && element.Direction === direction && element.Division === null && divisionChecked.indexOf(element.Entite) === -1) {
            divisionChecked.push(element.Entite);
            const Departement = [];
            Departement['Responsable'] = element;
            Departement['Members'] = [];
            const subDiv = element.Entite + '-'
            this.allOrganisation.forEach(elmnt => {
              if (elmnt.IntitulePoste.toUpperCase().indexOf('CHEF DU DÉPARTEMENT') !== -1 && elmnt.Direction === direction && elmnt.Division !== null && elmnt.Division !== undefined && elmnt.Division.indexOf(subDiv) !== -1) {
                divisionChecked.push(elmnt.Division);
                const Division = [];
                Division['Responsable'] = elmnt;
                Division['Members'] = [];
                this.allOrganisation.forEach(serv => {
                  if (serv.Division === elmnt.Division && serv.Direction === direction && serv.IntitulePoste.toUpperCase().indexOf('CHEF DE LA DIVISION') !== -1) {
                    divisionChecked.push(serv.Division);
                    const Service = [];
                    Service['Responsable'] = serv;
                    Division['Members'].push(Service);
                  }
                });
                Departement['Members'].push(Division);
              }
              // Correction MEHDI
              else if (element.Entite === elmnt.Entite && elmnt.Direction === direction && elmnt.IntitulePoste.toUpperCase().indexOf('CHEF DE LA DIVISION') !== -1) {
                divisionChecked.push(elmnt.Division);
                const Division = [];
                Division['Responsable'] = elmnt;
                Division['Members'] = [];
                this.allOrganisation.forEach(serv => {
                  if (serv.Division === elmnt.Division && serv.Direction === direction && serv.IntitulePoste.toUpperCase().indexOf('CHEF DE LA DIVISION') !== -1) {
                    divisionChecked.push(serv.Division);
                    const Service = [];
                    Service['Responsable'] = serv;
                    Division['Members'].push(Service);
                  }
                });
                Departement['Members'].push(Division);
              }

            });
            orga['Members'].push(Departement);
          }
          else
           if (element.Division !== null && element.Direction === direction && element.Division !== undefined && element.Division.indexOf(subDept) !== -1
            && element.IntitulePoste.toUpperCase().indexOf('CHEF DU DÉPARTEMENT') !== -1 && divisionChecked.indexOf(element.Division) === -1) {
            divisionChecked.push(element.Division);
            const Departement = [];
            Departement['Responsable'] = element;
            Departement['Members'] = [];
            const subDiv = element.Division + '-'
            this.allOrganisation.forEach(elmnt => {
              if (elmnt.IntitulePoste.toUpperCase().indexOf('CHEF DE LA DIVISION') !== -1 && elmnt.Direction === direction && elmnt.Division.indexOf(subDiv) !== -1) {
                divisionChecked.push(elmnt.Division);
                const Division = [];
                Division['Responsable'] = elmnt;
                Division['Members'] = [];
                // this.allOrganisation.forEach(serv => {
                //   if(serv.Division === elmnt.Division  && serv.IntitulePoste.toUpperCase().indexOf('CHEF DU SERVICE') !== -1 ) {
                //       divisionChecked.push(serv.Division);
                //       const Service = [];
                //       Service['Responsable']=serv;
                //       Division['Members'].push(Service);
                //     }
                // });
                Departement['Members'].push(Division);
              }

            });
            orga['Members'].push(Departement);
          }
          else if (element.Division !== null && element.Direction === direction && element.Division !== undefined && element.Division.indexOf(subDept) !== -1
            && divisionChecked.indexOf(element.Division) === -1 && element.IntitulePoste.toUpperCase().indexOf('CHEF DE LA DIVISION') !== -1) {
            const Division = [];
            Division['Responsable'] = element;
            Division['Members'] = [];
            // this.allOrganisation.forEach(serv => {
            //   if(serv.Division === element.Division  && element.IntitulePoste.toUpperCase().indexOf('CHEF DU SERVICE') !== -1 ) {
            //       divisionChecked.push(serv.Division);
            //       const Service = [];
            //       Service['Responsable']=serv;
            //       Division['Members'].push(Service);
            //     }
            // });
            orga['Members'].push(Division);
          }
          else if (element.Division !== null && element.Division !== undefined && direction === element.Direction
            && divisionChecked.indexOf(element.Division) === -1 && element.IntitulePoste.toUpperCase().indexOf('CHEF DU DÉPARTEMENT') !== -1) {
            divisionChecked.push(element.Division);
            const Departement = [];
            Departement['Responsable'] = element;
            Departement['Members'] = [];
            const subDiv = element.Division + '-'
            this.allOrganisation.forEach(elmnt => {
              if (elmnt.IntitulePoste.toUpperCase().indexOf('CHEF DE LA DIVISION') !== -1 && elmnt.Division.indexOf(subDiv) !== -1) {
                divisionChecked.push(elmnt.Division);
                const Division = [];
                Division['Responsable'] = elmnt;
                Division['Members'] = [];
                // this.allOrganisation.forEach(serv => {
                //   if(serv.Division === elmnt.Division  && serv.IntitulePoste.toUpperCase().indexOf('CHEF DU SERVICE') !== -1 ) {
                //       divisionChecked.push(serv.Division);
                //       const Service = [];
                //       Service['Responsable']=serv;
                //       Division['Members'].push(Service);
                //     }
                // });
                Departement['Members'].push(Division);
              }

            });
            orga['Members'].push(Departement);
          }
          else if (element.Division !== null && element.Division !== undefined && direction === element.Direction
            && element.IntitulePoste.toUpperCase().indexOf('CHEF DE LA DIVISION') !== -1 && divisionChecked.indexOf(element.Division) === -1) {
            const Service = [];
            Service['Responsable'] = element;
            orga['Members'].push(Service);
          }


        });
      }
      this.miniOrganisation = orga;
      if (orga['Members'].length > 0) {
        this.selectedOrga = true;
      } else {
        this.showModalPerson(orga);
      }

    } else if (item['Members'] !== undefined && item['Members'] !== null && item['Members'].length > 0) {
      this.miniOrganisation = item;
    } else {
      this.showModalPerson(item);
    }
  }
  chunk() {
    return _.chunk(this.miniOrganisation["Members"], 4);
  }
  getItemPicture(item) {
    let myImg = 'assets/media/images/avatar.png';
    if (item !== null && item !== undefined && item.AttachmentFiles != null && item.AttachmentFiles.length > 0) {
      item.AttachmentFiles.forEach(element => {
        if (element.FileName.toUpperCase().indexOf('.JPG') !== -1
          || element.FileName.toUpperCase().indexOf('.JPEG') !== -1 || element.FileName.toUpperCase().indexOf('.PNG') !== -1) {
          myImg = this.global._baseUrlRacine + element.ServerRelativeUrl
        }
      });
    }
    return myImg;
  }
  showModalPerson(item) {
    if (item['Responsable'] !== null && item['Responsable'] !== undefined) {
      this.showItemProfile = item['Responsable'];
    } else if (item['metadata'] !== null && item['metadata'] !== undefined) {
      this.showItemProfile = item['metadata'];
    } else {
      this.showItemProfile = item
    }
    const showBtnProfile = document.getElementById('showProfile');
    showBtnProfile.click();
  }
}

